import React from "react";
import { MdOpenInNew } from "react-icons/md";

export const OpenInNewIcon = ({ href, size = 14 }: { href: string; size?: number }): JSX.Element => {
  return (
    <a target="_blank" href={href}>
      <MdOpenInNew className="absolute top-2 right-2 cursor-pointer hover:text-slate-600" size={size} />
    </a>
  );
};
